import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { HelpConfig } from '@config/help-config';
import { FinancialReleasesReturnModel } from '@core/models/financeiro/financial-release-return.model';

@Injectable({
  providedIn: 'root',
})
export class FinancialService {

  private readonly url = `${this.helpConfig.FINANCIAL_API}`;

  constructor(private httpClient: HttpClient, private helpConfig: HelpConfig) { }

  financialReleases(cnpj: string, params: { [param: string]: string }): Observable<FinancialReleasesReturnModel> {
    const path = `${this.helpConfig.FINANCIAL_API}LancamentosFinanceiros/GetByCnpjWithFilter/${cnpj}`;
    return this.httpClient.get<FinancialReleasesReturnModel>(path, { params });
  }

  financialReleasesPendent(cnpj: string, initialDate: string, finalDate: string): Observable<FinancialReleasesReturnModel> {
    const path = `${this.helpConfig.FINANCIAL_API}LancamentosFinanceiros/GetByCnpjWithFilter/${cnpj}?status=v&status=A&dataVencimentoInicio=${initialDate}&dataVencimentoFim=${finalDate}`;
    return this.httpClient.get<FinancialReleasesReturnModel>(path);
  }
}
